// src/utils/visualMode.js
import { useEffect, useState } from "react";

const STORAGE_KEY = "bbx:visual-mode";

// Yksinkertainen globaali store moduulin sisällä
let currentMode = "minimal"; // "full" | "minimal"
const listeners = new Set();

/**
 * Päivitä <body data-visual="..."> turvallisesti
 */
function updateBodyDataset(mode) {
  if (typeof document === "undefined") return;
  const body = document.body;
  if (!body) return;

  if (mode === "minimal") {
    body.dataset.visual = "minimal";
  } else {
    delete body.dataset.visual;
  }
}

/**
 * Ilmoita kaikille hookeille että tila vaihtui
 */
function notify() {
  for (const fn of listeners) {
    try {
      fn(currentMode);
    } catch {
      // ei kaadeta mitään, jos joku kuuntelija räjähtää
    }
  }
}

/**
 * Aseta visuaalimoodi globaalisti:
 *  - currentMode päivittyy
 *  - <body data-visual> päivittyy
 *  - localStorage päivittyy
 *  - kaikki useVisualMode-hookit päivittyvät
 */
export function setVisualMode(mode) {
  const normalized = mode === "minimal" ? "minimal" : "full";
  currentMode = normalized;

  updateBodyDataset(normalized);

  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // ei väkisin
  }

  notify();
}

/**
 * Luetaan edellinen valinta talteen jo ennen Reactin boottausta.
 * Kutsutaan index.js:ssä.
 */
export function applyVisualModeFromStorage() {
  if (typeof document === "undefined") return;

  let saved = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch {}

  const initial = saved === "full" ? "full" : "minimal";
  // Tämä päivittää myös body.dataset.visual ja currentMode:n
  setVisualMode(initial);
}

/**
 * React-hook, jota CookieConsent, motionSafe jne. voivat käyttää.
 * Kaikki käyttävät samaa globaalia tilaa (currentMode).
 */
export function useVisualMode() {
  const [mode, setModeState] = useState(currentMode);

  useEffect(() => {
    // rekisteröidään kuuntelija
    const handler = (nextMode) => {
      setModeState(nextMode);
    };
    listeners.add(handler);

    // cleanup
    return () => {
      listeners.delete(handler);
    };
  }, []);

  const setMode = (next) => {
    const normalized = next === "minimal" ? "minimal" : "full";
    setVisualMode(normalized);
  };

  return {
    mode,
    isMinimal: mode === "minimal",
    setMode,
  };
}
